import { Injectable } from '@angular/core';

@Injectable()
export class DataShareService {

    private map : {};
    
    constructor() { 
        this.map = [];
    }

    put(key:string, value){
        //this.map[key] = value;
        localStorage.setItem(key, JSON.stringify(value));
    }
    
    get(key: string){
        //return this.map[key];
        return JSON.parse(localStorage.getItem(key));
    }
    
    remove(key: string){
        //delete (this.map[key]);
        localStorage.removeItem(key);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/data-share.service.ts